import { Html5QrcodeScanner, Html5QrcodeScannerState } from "html5-qrcode";
import { IQRCodeScanner, IQRCodeScannerFactory } from './IQRCodeScanner';

// Wrapper around the real Html5QrcodeScanner that implements our interface
class Html5QrcodeScannerWrapper implements IQRCodeScanner {
    private scanner: Html5QrcodeScanner;

    constructor(elementId: string, config: any, verbose?: boolean) {
        this.scanner = new Html5QrcodeScanner(elementId, config, verbose);
    }

    render(qrCodeSuccessCallback: (decodedText: string, result: any) => void, qrCodeErrorCallback?: (errorMessage: string) => void): void {
        this.scanner.render(qrCodeSuccessCallback, qrCodeErrorCallback);
    }

    pause(shouldPauseVideo?: boolean): void {
        this.scanner.pause(shouldPauseVideo);
    }

    resume(): void {
        this.scanner.resume();
    }

    clear(): Promise<void> {
        return this.scanner.clear();
    }

    stop(): Promise<void> {
        // Html5QrcodeScanner only has clear() method, not stop()
        return this.scanner.clear();
    }

    getState(): string {
        // Convert the enum value to string for consistent interface
        return this.scanner.getState().toString();
    }
}

// Factory for creating QR code scanners
export class Html5QrcodeFactory implements IQRCodeScannerFactory {
    create(elementId: string, config: any, verbose?: boolean): IQRCodeScanner {
        return new Html5QrcodeScannerWrapper(elementId, config, verbose);
    }
}

// Export scanner states for use in the controller
export { Html5QrcodeScannerState } from "html5-qrcode";
